import {createApp} from 'vue'
import DanmarksKort from './DanmarksKort'

const el = '.kb-component--danmarks-kort'

const LABEL_PROPS = [
    'mapPanelLabel',
    'searchButtonLabel',
    'searchNoResultsLabel',
    'searchLabelCountry',
    'searchLabelMunicipality',
    'searchLabelSundhedsraad',
    'accessibilityListLabelMunicipality',
    'accessibilityListLabelSundhedsraad',
    'legendLabel',
    'srTabLabelSundhedsraad',
    'srTabLabelKommuner',
    'srToggleAriaLabel',
    'srSectionHeading',
    'kommunerSectionHeading',
    'municipalityNameSuffix',
    'disclaimerText',
    'loadErrorLabel',
]

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((DanmarksKortDOM)=>{
            const data = DanmarksKortDOM.dataset
            const props = {
                title:     data.title ?? '',
                flow:      data.flow  ?? 'municipality',
                groupData: data.groupData
                    ? JSON.parse(data.groupData)
                    : [],
                municipalityDataUrl: data.municipalityDataUrl ?? '/api/map-data-{key}.json',
                legend: data.legend
                    ? JSON.parse(data.legend)
                    : undefined
            }
            LABEL_PROPS.forEach((prop)=>{
                if (data[prop]) props[prop] = data[prop]
            })
            const component = createApp(DanmarksKort, props).use(Store)
            component.mount(DanmarksKortDOM)
        })
    }
}
